// ============================================================================
// src/sheep/SheepEntry.tsx — the sheep domain's nested routes.
// ============================================================================
// B3.1 finish, second domain. Replaces resolveSheepEntry with the shape the
// spec asks for — App owns one top-level route per domain, the domain owns its
// own nested routes. See src/cattle/CattleEntry.jsx for the pattern and
// src/app/navigation/viewRoutes.js for why the `location` prop is the ROUTED
// location rather than the raw one.
// ============================================================================
import React from 'react';

import {AppRoute, AppRoutes} from '../app/navigation/index.js';
import {SHEEP_ROUTES} from './sheepRoutes.js';

import SheepHomeView from './SheepHomeView.tsx';
import SheepFlocksView from './SheepFlocksView.tsx';
import SheepBatchesView from './SheepBatchesView.tsx';
import SheepDailysView from './SheepDailysView.tsx';
import SheepWeighInsView from './SheepWeighInsView.tsx';
import PageBoundary from '../app/PageBoundary.tsx';

export {SHEEP_ROUTES};

// Declared here rather than imported from CattleEntry: the five domain entries
// share a shape, not a module, and a cross-domain import would add an edge to
// the graph the route guards walk. See CattleEntry for the same two aliases.
type RoutedLocationProp = string | {pathname: string; search?: string; hash?: string; state?: unknown};

type SheepEntryProps = {
  location: RoutedLocationProp;
};

export function SheepEntry({location}: SheepEntryProps) {
  const routes = (
    <AppRoutes location={location}>
      <AppRoute path="/sheep" element={<SheepHomeView />} />
      <AppRoute path="/sheep/flocks/*" element={<SheepFlocksView />} />
      <AppRoute path="/sheep/batches/*" element={<SheepBatchesView />} />
      <AppRoute path="/sheep/dailys/*" element={<SheepDailysView />} />
      <AppRoute path="/sheep/weighins" element={<SheepWeighInsView />} />
    </AppRoutes>
  );
  // N12: a crash in the routed page stays inside it; App and the header
  // stay mounted (src/app/PageBoundary).
  return <PageBoundary>{routes}</PageBoundary>;
}

export default SheepEntry;
